import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'
import { IPayload } from '../../models/Global'
import {
  IShiftPreferencesAdvanced,
  IMuteUnmuteShiftPreferencesAdvancedParams,
} from '../../models/ShiftPreferencesAdvanced'

export class ShiftPreferencesAdvancedApi {
  constructor(private axios: AxiosService) {}

  shiftPreferencesAdvancedMuteBusiness = async (
    params: IMuteUnmuteShiftPreferencesAdvancedParams
  ) => {
    const response = await this.axios.post<IPayload<IShiftPreferencesAdvanced>>(
      Endpoints.shiftPreferencesAdvancedMuteBusiness,
      params
    )
    return response
  }

  shiftPreferencesAdvancedUnmuteBusiness = async (
    params: IMuteUnmuteShiftPreferencesAdvancedParams
  ) => {
    const response = await this.axios.post<IPayload<IShiftPreferencesAdvanced>>(
      Endpoints.shiftPreferencesAdvancedUnmuteBusiness,
      params
    )
    return response
  }
}
